var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1F6E0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8899A6",
    d: "M34.247 6.324l-2.742 2.743s-1.829.914-3.657-.915c-1.829-1.828-.915-3.657-.915-3.657l2.743-2.743C30.591.838 29.492 0 28.667 0c-4.051 0-7.334 3.283-7.334 7.333 0 .569.072 1.121.194 1.653l-6.199 6.199 5.485 5.485 6.199-6.198c.533.122 1.084.194 1.654.194 4.05 0 7.333-3.283 7.333-7.333.001-.83-.838-1.923-1.752-1.009zm-19.027 9.04L3.031 27.552c-1.495 1.496-1.495 3.921 0 5.417 1.497 1.495 3.921 1.495 5.417 0l12.187-12.188-5.415-5.417zM5.763 31.838c-.819 0-1.482-.664-1.482-1.482s.664-1.483 1.482-1.483c.819 0 1.482.664 1.482 1.483 0 .818-.663 1.482-1.482 1.482z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M30.83 33.279c1.166 1.166 3.022 1.221 4.121.121 1.1-1.1 1.045-2.955-.121-4.121L11.565 6.014c-1.167-1.167-3.021-1.221-4.121-.121-1.1 1.1-1.045 2.955.121 4.121L30.83 33.279z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M21.444.893s-6-3-11 2l-7 7s-1-1-2 0l-1 1s-1 1 0 2l4 4s1 1 2 0l1-1s1-1 0-2l-.078-.078c.77-.743 1.923-1.5 3.078-.922l4-4s-1-3 1-5 3-2 5-2 1-1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F6E0);
export default __webpack_public_path__ + "static/media/1f6e0.18a6a1b2b9f68a15332ffdaa2c8d5261.svg";
export { ForwardRef as ReactComponent };